import { Box, Input, InputProps, Text } from '@tonic-one/react';
import React, { useImperativeHandle, useRef } from 'react';
import { ValidProps } from 'src/types';

export interface InputChildRef {
  errorMsg: string | undefined;
  validate: (value: string) => void;
  reset: () => void;
}

export interface InputWithValidProps extends Omit<InputProps, 'onChange'> {
  onChange: (value: string) => void;
  validates: ValidProps[];
  maxLength: number;
  value?: string;
}

export const InputWithValid = React.forwardRef<Input, InputWithValidProps>(
  (props, ref) => {
    const { onChange, validates, value, ...rest } = props;
    const [errorMsg, setErrorMsg] = React.useState<string | undefined>(
      undefined
    );
    const inputRef = useRef<InputChildRef | null>(null);
    useImperativeHandle(
      ref,
      (): {
        errorMsg: string | undefined;
        validate: (value: string) => void;
        reset: () => void;
      } => ({
        // 暴露的属性
        validate,
        errorMsg,
        reset,
      })
    );

    const validate = (value: string) => {
      let isValid = true;
      validates.forEach((valid) => {
        if (!valid.validMethod(value)) {
          isValid = false;
          setErrorMsg(valid.errMsg);
        }
      });
      if (isValid) {
        setErrorMsg(undefined);
      }
    };

    const reset = () => {
      setErrorMsg(undefined);
    };
    const InlineError = (props: any) => (
      <Text fontSize="sm" lineHeight="sm" color="red:50" {...props} />
    );
    return (
      <Box flexDirection="column">
        <Input
          ref={inputRef}
          value={value ? value : ''}
          onChange={(e: any) => {
            validate(e.target.value);
            onChange(e.target.value);
          }}
          error={errorMsg !== undefined}
          {...rest}
        />
        <Box>
          {errorMsg !== undefined && <InlineError>{errorMsg}</InlineError>}
        </Box>
      </Box>
    );
  }
);
